export default __webpack_public_path__ + "static/media/photo 19.24034ee5.jpg";